(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('FilterListFilterService', FilterListFilterService);
    var urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.

    function FilterListFilterService(lodash, FILTER_STEP_CONSTANT, FILTER_OPERATOR_CONSTANT, FilterComposer, GenericModel, ActionCommon, ActionManager, $q, $filter) {
        return function (mem) {
            return {
                init: init,
                getFilterList: getFilterList,
                goToNext: goToNext,
                backToPrevious: backToPrevious,
                selectFilter: selectFilter,
                applyFilter: applyFilter,
                clearCurrentFilter: clearCurrentFilter,
                resetCurrent: resetCurrent,
                clearFilters: clearFilters,
                prepareFilterOptionValues: prepareFilterOptionValues,
                getFilterOptionValues: getFilterOptionValues,
                getFilterOptionInputConfig: getFilterOptionInputConfig,
                getAppliedFilters: getAppliedFilters,
                hasAppliedFilters: hasAppliedFilters,
                getFilter: getFilter,
                getAppliedFilter: getAppliedFilter,
                getLabel: getLabel,
                editFilter: editFilter,
                removeFilter: removeFilter,
                applyView: applyView,
                createView: createView,
                updateView: updateView,
                deleteView: deleteView,
                getFilterData: getFilterData,
                setActiveFilter: setActiveFilter,
                setAppliedFilters: setAppliedFilters,
                getActiveFilters: getActiveFilters,
                hasFilter: hasFilter,
            };

            function init() {
                mem.pageData.filters = mem.options.filters;


                if (mem.pageData.filters.active_filters instanceof Array || lodash.isEmpty(mem.pageData.filters.active_filters)) {
                    mem.pageData.filters.active_filters = {};
                }
                if (!lodash.has(mem.pageData.filters, 'active_filters.applied')) {
                    lodash.set(mem.pageData, 'filters.active_filters.applied', []);
                }

                if (!lodash.isEmpty(mem.pageData.filters.active_filters.applied)) {
                    mem.pageData.sidebar_active = true;
                }

                if (lodash.has(mem.options, 'status_selection.default')) {
                    // var default_pipeline = mem.options.status_selection.default;

                    // if (!lodash.isEqual(default_pipeline, skip_pipeline)) {

                        lodash.set(mem, 'pageData.filters.active_filters.pipeline', [angular.merge({}, {value: mem.options.status_selection.default}, mem.options.status_selection.filter_template)]);
                    // }
                }
                if (lodash.has(mem.pageData.filters, 'active_filters.search')) {
                    const firstSearchValue = lodash.first(mem.pageData.filters.active_filters.search);
                    if (firstSearchValue) {
                        setSearchBar(firstSearchValue.value);
                    }
                }

                const sidebar_active_option = lodash.get(mem.options, 'filters.sidebar_active', false);
                if (!mem.pageData.sidebar_active) {
                    mem.pageData.sidebar_active = sidebar_active_option;
                }

            }

            function getFilter(fieldName) {
                return lodash.find(mem.pageData.filters.list, {name: fieldName});
            }

            function getAppliedFilter(fieldName) {
                return lodash.find(mem.pageData.filters.active_filters.applied, {field: fieldName});
            }

            function getAppliedFilterList() {
                var appliedFilters = lodash.get(mem, 'options.filters.active_filters.applied', []);

                var appliedFilterPromises = lodash.map(appliedFilters, function (appliedFilter) {
                    var filter = lodash.find(lodash.get(mem, 'options.filters.list', []), { name: appliedFilter.field }, {});
                    var filterOptionDatasource = lodash.get(filter, 'options.datasource', {});
                    var url = filterOptionDatasource.url;
                    var method = filterOptionDatasource.method;
                    var model = new GenericModel(url);
                    var data = {};
                    if (lodash.get(filterOptionDatasource, 'limited', false) === true && !lodash.isEmpty(appliedFilter.value)) {
                        data = {
                            data: {
                                applied_filter: appliedFilter.value
                            }
                        }
                    }

                    if(model && method){
                        return model[method](data).$promise;
                    }
                });

                $q.all(appliedFilterPromises)
                    .then(function (appliedFilterResponses) {
                        lodash.forEach(appliedFilters, function (appliedFilter, appliedFilterIndex) {
                            var listFilterIndex = lodash.findIndex(lodash.get(mem, 'options.filters.list', []), { name: appliedFilter.field });

                            if (listFilterIndex >= 0) {
                                lodash.set(mem, 'options.filters.list[' + listFilterIndex + '].options.data', appliedFilterResponses[appliedFilterIndex].data);
                            }
                        });
                    });
            }

            function getFilterList() {
                if (lodash.has(mem.options.filters, 'datasource.init')) {
                    var url = mem.options.filters.datasource.init.url;
                    var method = mem.options.filters.datasource.init.method;
                    var model = new GenericModel(url);

                    lodash.set(mem.pageData, 'filters.loading', true);
                    model[method]().$promise.then(function (res) {
                        lodash.set(mem.pageData, 'filters.list', res.types);
                        lodash.set(mem.pageData, 'filters.filter_options', res.options);
                        if (!lodash.isEmpty(lodash.get(mem.pageData, 'view_options', false))) {
                            if (lodash.has(res, 'saved_views.options')) {
                                lodash.set(mem.pageData, 'view_options.data', res.saved_views.options);
                                const selectedView = lodash.find(res.saved_views.options, {select_id: _.get(mem.pageData.filters, 'active_filters.view.select_id', null)});
                                if (selectedView) {
                                    mem.pageData.view_options.selected_view = selectedView;
                                } else {
                                    mem.pageData.view_options.selected_view = null;
                                }
                            }
                        }
                        lodash.set(mem.pageData, 'filters.permission.shared_to_everyone', lodash.get(res.saved_views, 'shared_to_everyone_visibility'));
                        lodash.set(mem.pageData, 'filters.title', lodash.get(res.saved_views, 'title'));
                        lodash.set(mem.pageData, 'filters.loading', false);
                        getAppliedFilterList();
                    }, function (res) {
                        console.warn(res); // eslint-disable-line no-console
                    });
                }
            }

            function getRemoteEnumData() {

            }

            function getLabel(name, overrideKey) {
                if (overrideKey && lodash.has(mem.pageData.filters.label, 'applied_filter_label_override.' + overrideKey)) {
                    return mem.pageData.filters.label.applied_filter_label_override[overrideKey];
                }
                return lodash.get(mem.pageData, ['filters', 'label', name].join('.'), '');
            }

            function goToNext() {
                // testing function
                switch (mem.pageData.filters.step) {
                    case FILTER_STEP_CONSTANT.LIST:
                        mem.pageData.filters.step = FILTER_STEP_CONSTANT.PROPERTY;
                        break;
                    case FILTER_STEP_CONSTANT.PROPERTY:
                        mem.pageData.filters.step = FILTER_STEP_CONSTANT.VALUES;
                        break;
                    case FILTER_STEP_CONSTANT.VALUES:
                    default:
                        mem.pageData.filters.step = FILTER_STEP_CONSTANT.LIST;
                        break;
                }
            }

            function backToPrevious() {
                switch (mem.pageData.filters.step) {
                    case FILTER_STEP_CONSTANT.PROPERTY:
                        mem.pageData.filters.step = FILTER_STEP_CONSTANT.LIST;
                        // clear filter property stuff
                        break;
                    case FILTER_STEP_CONSTANT.VALUES:
                        mem.pageData.filters.step = FILTER_STEP_CONSTANT.PROPERTY;
                        break;
                    default:
                        break;
                }
            }

            function selectFilter(filter) {
                mem.pageData.filters.current = angular.copy(filter);
                goToNext();
            }

            function clearCurrentFilter() {
                mem.pageData.filters.current = null;
            }

            function applyFilter() {
                var currentOperator = lodash.get(mem.pageData.filters, 'current.operator', false);
                var field = lodash.get(mem.pageData.filters, 'current.name', '');
                var filterType = lodash.get(mem.pageData.filters, 'current.type', '');

                if (!currentOperator) {
                    return false;
                }
                var currentOption = lodash.find(mem.pageData.filters.currentOptions, {operator: currentOperator});

                var value = lodash.get(currentOption, 'value', false);
                if ($filter('isMultipleEnumType')(filterType)) {
                    var currentFilter = lodash.get(mem.pageData.filters, 'current');
                    var currentFilterSubSettings = lodash.get(currentFilter, 'settings.sub_settings', {});
                    var currentFilterSubKeys = lodash.keys(currentFilterSubSettings);

                    // fix if selected any and then removing aka []
                    const cleansedValue = $filter('cleanseValue')(value);

                    
                    var valueKeys = lodash.keys(cleansedValue);
                    var uniqueValueKeys = lodash.xor(valueKeys, currentFilterSubKeys);
                    if (uniqueValueKeys.length !== 0) {
                        return false;
                    }
                }

                if ([FILTER_OPERATOR_CONSTANT.EXISTS, FILTER_OPERATOR_CONSTANT.NOT_EXISTS, FILTER_OPERATOR_CONSTANT.IS, FILTER_OPERATOR_CONSTANT.BETWEEN].indexOf(currentOperator) < 0) {
                    switch(filterType) {
                        case 'number':
                            if (isNaN(value)) {
                                return false;
                            }
                            break;
                        case 'date':
                            if (!lodash.isDate(value)) {
                                return false;
                            }
                            break;
                        default:
                            if (lodash.isEmpty(value)) {
                                return false;
                            }
                            break;
                    }
                }
                if ([FILTER_OPERATOR_CONSTANT.BETWEEN].indexOf(currentOperator) >= 0) {
                    if (filterType === 'number') {
                        if (isNaN(value.lower) || isNaN(value.upper)) {
                            return false;
                        }
                    }
                    if (filterType === 'date') {
                        if (!lodash.isDate(value.lower) || !lodash.isDate(value.upper)) {
                            return false;
                        }
                    }
                }

                // Fix ENUM REMOTE
                var hasDatasource = Boolean(lodash.get(mem.pageData.filters, 'current.options.datasource', false));
                var filterData = lodash.get(mem.pageData.filters, 'current.options.data', false);

                var filterEdit = lodash.get(mem.pageData, 'filters.filterEdit', false);
                if (filterEdit) {
                    FilterComposer.editFilter(
                        filterEdit,
                        currentOperator,
                        value,
                        hasDatasource && filterData ? filterData : null
                    );
                } else {
                    var filter = FilterComposer.constructFilter(
                        field,
                        currentOperator,
                        value,
                        hasDatasource && filterData ? filterData : null
                    );
                    // var exists = lodash.find(mem.pageData.filters.active_filters.applied, filter);
                    // var type = lodash.get(mem.pageData.filters, 'current.type', false);

                    // if (type == 'enum') {
                    //     var appliedFilter = getAppliedFilter(field);
                    //     if (appliedFilter) {
                    //         appliedFilter.value = value;
                    //         appliedFilter.operator = currentOperator;
                    //     } else {
                    //         mem.pageData.filters.active_filters.applied.push(filter);
                    //     }
                    // } else {
                    //     if (exists) {
                    //         ActionCommon.show_floating_notifier(mem.pageData.filters.notifier.exists);
                    //         // {
                    //         //     template: 'Filter already exists',
                    //         //         hasDelay: true,
                    //         //     delay: 70000,
                    //         //     type: 'warning', // default success warning info error
                    //         //     position: 'top right'
                    //         // }
                    //     } else {
                    mem.pageData.filters.active_filters.applied.push(filter);
                        // }
                    // }
                }
                return true;
            }

            function resetCurrent() {
                mem.pageData.filters.step = -1;
                mem.pageData.filters.current = null;
                mem.pageData.filters.currentOptions = null;
                mem.pageData.filters.editing = false;
                lodash.set(mem.pageData, 'filters.filterEdit', false);
                goToNext();
            }

            function clearFilters() {
                mem.pageData.filters.active_filters.applied = [];
                delete mem.pageData.filters.active_filters.view;
                // delete mem.pageData.filters.active_filters.pipeline;
                delete mem.pageData.filters.active_filters.search;
                clearSearchBar();
                mem.pageData.view_options.selected_view = null;
                resetCurrent();
            }

            function editFilter(filter) {
                if (filter.lock) {
                    return;
                }
                lodash.set(mem.pageData, 'filters.filterEdit', filter);
                mem.pageData.filters.editing = true;
                // need to get the filter from filterList,
                mem.pageData.filters.current = angular.copy(lodash.find(mem.pageData.filters.list, {name: filter.field}));

                // if (lodash.has(mem.pageData.filters.current.options, 'datasource') && lodash.get(mem.pageData.filters.current.options, 'datasource.limited', false)) {
                //     lodash.set(mem.pageData.filters.current.options, 'data', lodash.get(filter, 'data', []))
                // }

                mem.pageData.filters.current.operator = filter.operator;

                // need to get the currentOptions,
                //prepareFilterOptionValues();


                // need to set the step = 3. Setting to PROPERTY here as gotoNext() will cause it to go to VALUES
                mem.pageData.filters.step = FILTER_STEP_CONSTANT.PROPERTY;
                goToNext();
            }

            function removeFilter(filter) {
                var index = mem.pageData.filters.active_filters.applied.indexOf(filter);
                mem.pageData.filters.active_filters.applied.splice(index, 1);
            }

            function prepareFilterOptionValues() {
                var type = lodash.get(mem.pageData.filters, 'current.type', '');
                var typedFilterOptions = lodash.get(mem.pageData.filters, 'filter_options.form.' + type + '.options', []);
                var standardFilterOptions = lodash.get(mem.pageData.filters, 'filter_options.standard', []);
                var filterSettings = lodash.get(mem.pageData.filters.current, 'settings', {});

                var currentOptions = angular.copy(typedFilterOptions);
                if (lodash.get(filterSettings, 'appendStandardOptions', true) === true) {
                    currentOptions = currentOptions.concat(angular.copy(standardFilterOptions));
                }

                if (lodash.get(filterSettings, 'hasAllOperator', false) === false) {
                    currentOptions = currentOptions.filter((_filter) => {
                        const operator = lodash.get(_filter, 'operator');
                        return operator.indexOf('_all') < 0;
                    });
                }

                if (lodash.has(filterSettings, 'filter_display_override')) {
                    currentOptions = currentOptions.map(function (option) {
                        const label = lodash.get(filterSettings.filter_display_override, option.operator, null);
                        if (!!label) {
                            option.label = lodash.get(mem.pageData.filters.label, 'operator_override.' + label, option.label);
                        }
                        return option;
                    });
                }

                mem.pageData.filters.currentOptions = currentOptions;

                // FOR EDITING OF FILTERS
                var filterEdit = lodash.get(mem.pageData, 'filters.filterEdit', false);
                if (filterEdit) {
                    // need to set the value in currentOptions
                    var currentOptionIndex = lodash.findIndex(mem.pageData.filters.currentOptions, {operator: filterEdit.operator});
                    mem.pageData.filters.currentOptions[currentOptionIndex].value = filterEdit.value;
                    //mem.pageData.filters.current.operator = mem.pageData.filters.currentOptions[currentOptionIndex].operator;
                }
                // else {
                //     if (type == 'enum') {
                //         var appliedFilter = getAppliedFilter(lodash.get(mem.pageData.filters, 'current.name', ''));
                //         if (appliedFilter) {
                //             var appliedOption = lodash.find(mem.pageData.filters.currentOptions, {operator: appliedFilter.operator});
                //             appliedOption.value = appliedFilter.value;
                //
                //             lodash.set(mem.pageData.filters, 'current.operator', appliedFilter.operator);
                //         }
                //     }
                // }
            }

            function getFilterOptionValues(type) {
                var typedFilterOptions = lodash.get(mem.pageData.filters, 'filter_options.form.' + type + '.options', []);
                var standardFilterOptions = lodash.get(mem.pageData.filters, 'filter_options.standard', []);
                return angular.copy(typedFilterOptions.concat(standardFilterOptions));
            }

            function getFilterOptionInputConfig(type) {
                var inputType = '';
                switch (type) {
                    case 'date':
                        inputType = 'datepicker';
                        break;
                    case 'enum':
                        inputType = 'select';
                        break;
                }
                return lodash.get(mem.pageData.filters, 'filter_options.form.' + type + '.config.' + inputType, {});
            }

            function getAppliedFilters() {
                // return lodash.get(mem.pageData.filters, 'applied', []);
                const filters = angular.copy(lodash.get(mem.pageData.filters, 'active_filters', {}));

                if (lodash.has(mem.pageData, 'view_options.selected_view') && !lodash.isEmpty(mem.pageData.view_options.selected_view)) {
                    filters.view = lodash.pick(mem.pageData.view_options.selected_view, ['select_id']);
                }

                delete filters.search;
                if (lodash.has(mem.pageData, 'toolbar.searchText') && !lodash.isEmpty(mem.pageData.toolbar.searchText)) {
                    filters.search = [
                        {
                            field: 'filter_search_text',
                            operator: 'contains',
                            value: mem.pageData.toolbar.searchText
                        }
                    ]
                }
                if ((lodash.has(mem.pageData, 'toolbar.searchData.items') && (mem.pageData.toolbar.searchData.items.length > 0))) {
                    filters.search = [
                        {
                            field: 'filter_search_array',
                            operator: 'search_array',
                            value: mem.pageData.toolbar.searchData
                        }
                    ]
                }

                if (lodash.has(mem.pageData, 'toolbar.filter')) {
                    if (this.getFilterBarQuery && (typeof this.getFilterBarQuery === typeof function() {})) {
                        console.log(this.getFilterBarQuery());
                        var filterbarFilters = this.getFilterBarQuery();

                        if (lodash.has(filters, 'applied')) {
                            filters.applied.concat(filterbarFilters.filters);
                        } else {
                            filters.applied = filterbarFilters.filters;
                        }
                    }
                }

                if (lodash.has(mem.options, 'status_selection.skip_pipeline')) {
                    var skip_pipeline = lodash.get(mem.options, 'status_selection.skip_pipeline');
                    filters.pipeline = filters.pipeline.reduce(function(result, item) {
                        if (!lodash.isEqual(skip_pipeline, item.value)) {
                            result.push(item);
                        }
                        return result;
                    }, []);
                }

                // if (lodash.has(mem, 'pageData.view_options_filters')) {
                //     const viewOptionsFilterOperator = lodash.get(mem.pageData, 'filter_options.operator', 'eq');
                //     lodash.forIn(mem.pageData.view_options_filters, function(viewOption, key) {
                //         console.log(viewOption, key);
                //         appliedFilters.push({
                //             field: key,
                //             operator: viewOptionsFilterOperator,
                //             value: viewOption
                //         })
                //     });
                // }

                return filters;
            }

            function hasAppliedFilters(includePipeline) {
                var filterbarFilters = [];
                if (this.getFilterBarQuery && (typeof this.getFilterBarQuery === typeof function() {})) {
                    console.log(this.getFilterBarQuery());
                    var filterbarQuery = this.getFilterBarQuery();
                    filterbarFilters = filterbarQuery.filters;
                }


                var conditions = [
                    (lodash.has(mem.pageData, 'filters.active_filters.applied') && (mem.pageData.filters.active_filters.applied.length > 0)),
                    // (lodash.has(mem.pageData.filters, 'active_filters.search.value') && !lodash.isEmpty(mem.pageData.filters.search.value)),
                    (lodash.has(mem.pageData, 'toolbar.searchText') && (mem.pageData.toolbar.searchText.length > 0)),
                    (lodash.has(mem.pageData, 'toolbar.searchData.items') && (mem.pageData.toolbar.searchData.items.length > 0)),
                    (lodash.has(mem.pageData, 'view_options.selected_view') && !lodash.isEmpty(mem.pageData.view_options.selected_view)),
                    filterbarFilters.length > 0
                ];

                if (includePipeline) {
                    conditions.push(lodash.has(mem.pageData, 'filters.active_filters.pipeline') && (mem.pageData.filters.active_filters.pipeline.length > 0) );
                }

                return lodash.compact(conditions).length > 0;
            }

            function setAppliedFilters(filters) {
                lodash.set(mem.pageData.filters, 'active_filters', filters);
                // if (lodash.has(mem.pageData.filters, 'active_filters.view.select_id')) {
                //     lodash.set(mem.pageData, 'view_options.selected_view', lodash.find(lodash.get(mem.pageData, 'view_options.data', []), {select_id: mem.pageData.filters.active_filters.view.select_id}));
                // }

                if (lodash.has(mem.pageData.filters, 'active_filters.search')) {
                    const firstSearchValue = lodash.first(mem.pageData.filters.active_filters.search);
                    // vm.pageData.toolbar.searchBarConfig.simple

                    if (firstSearchValue) {
                        setSearchBar(firstSearchValue.value);
                    }

                } else {
                    clearSearchBar();
                }
            }

            function getFilterData() {
                return mem.pageData.filters;
            }

            function applyView() {
                const selectedView = mem.pageData.view_options.selected_view;
                const ds = mem.pageData.filters.datasource.saved_view.get;
                const url = decodeURI(ds.url).replace(urlReplacerRegex, (match, submatch) => {
                    return lodash.get(selectedView, submatch, '');
                });
                const method = lodash.get(ds, 'method', 'get');
                const resource = GenericModel(url);

                resource[method]({ filter_id: selectedView.id }).$promise.then(function(res) {
                    if(res.data.active_status == 'del'){
                        clearFilters();
                        mem.currentScope.listFilterService.refreshGrid(true);
                    }else{
                        setAppliedFilters(res.data.filter);
                        mem.pageData.grid.dataSource.page(1);
                        lodash.set(mem.pageData.filters, 'active_filters.view.select_id', res.data.select_id);
                    }
                    refreshView();
                }, function(res) {
                    // Todo: show notification
                });
            }

            function refreshView() {
                const ds = mem.pageData.filters.datasource.saved_view.getArray;
                const url = decodeURI(ds.url).replace(urlReplacerRegex, () => {
                    return '';
                });
                const method = lodash.get(ds, 'method', 'get');
                const params = lodash.get(ds, 'params', {});
                const resource = GenericModel(url);
                resource[method](params).$promise.then(function(res) {
                    lodash.set(mem.pageData, 'view_options.data', res.rows);
                    const selectedView = lodash.find(res.rows, { select_id: _.get(mem.pageData.filters, 'active_filters.view.select_id', null)});
                    if (selectedView) {
                        mem.pageData.view_options.selected_view = selectedView;
                    } else {
                        mem.pageData.view_options.selected_view = null;
                    }
                }, function(err) {
                    // Todo: show err notification
                    console.log(err);
                });
            }

            function createView() {
                $q.when(ActionManager('dm-open-dialog', {
                    controller: 'ListFilterSaveViewFormCtrl',
                    templateUrl: 'common/app/components/list-filter/save-view-form',
                    dialog_options: {
                        viewName: '',
                        shareWithAll: false,
                        shareToEveryoneVisibility: mem.pageData.filters.permission.shared_to_everyone,
                        title: mem.pageData.filters.title
                    }
                }), function(res) {
                    res.modal.closed.then(function(resViewName) {
                        if (resViewName !== false) {
                            const appliedFilters = getAppliedFilters();
                            const ds = mem.pageData.filters.datasource.saved_view.create;
                            const url = ds.url;
                            const method = lodash.get(ds, 'method', 'post');
                            const params = lodash.merge({
                                saved_view_name: resViewName.saved_view_name,
                                shared_with_all: resViewName.shared_with_all,
                                filter: appliedFilters
                            }, lodash.get(ds, 'params', {}));

                            const resource = GenericModel(url);
                            resource[method]({ data: params }).$promise.then(function(res) {
                                if (lodash.has(res, 'select_id')) {
                                    lodash.set(mem.pageData.filters, 'active_filters.view.select_id', res.select_id);
                                }
                                refreshView();
                                ActionManager('notify', lodash.get(mem.options, 'view_options.notification.create.success', {
                                    template: 'create success',
                                }))
                            }, function(res) {
                               console.log('error res', res);
                                ActionManager('notify', lodash.get(mem.options, 'view_options.notification.create.error', {
                                    template: 'create error',
                                }))
                            });
                        }
                    });
                });
            }

            function updateView() {
                const selectedView = mem.pageData.view_options.selected_view;
                $q.when(ActionManager('dm-open-dialog', {
                    controller: 'ListFilterSaveViewFormCtrl',
                    templateUrl: 'common/app/components/list-filter/save-view-form',
                    dialog_options: {
                        viewName: selectedView.label,
                        shareWithAll: selectedView.shared_with_all,
                        shareToEveryoneVisibility: mem.pageData.filters.permission.shared_to_everyone,
                        title: mem.pageData.filters.title
                    }
                }), function(res) {
                    res.modal.closed.then(function(resViewName) {
                        if (resViewName !== false) {
                            const appliedFilters = getAppliedFilters();
                            const ds = mem.pageData.filters.datasource.saved_view.update;
                            const url = decodeURI(ds.url).replace(urlReplacerRegex, (match, submatch) => {
                                return lodash.get(selectedView, submatch, '');
                            });
                            const method = lodash.get(ds, 'method', 'put');
                            const params = lodash.merge({
                                saved_view_name: resViewName.saved_view_name,
                                shared_with_all: resViewName.shared_with_all,
                                filter: appliedFilters
                            }, lodash.get(ds, 'params', {}));

                            const resource = GenericModel(url);
                            resource[method]({ data: params }).$promise.then(function() {
                                refreshView();

                                ActionManager('notify', lodash.get(mem.options, 'view_options.notification.update.success', {
                                    template: 'update success',
                                }))
                            }, function(res) {
                                console.warn('error res', res);
                                ActionManager('notify', lodash.get(mem.options, 'view_options.notification.update.error', {
                                    template: 'update error',
                                }))
                            });
                        }
                    });
                });
            }

            function deleteView() {
                $q.when(ActionManager('dm-open-dialog', {
                    template: mem.options.view_options.onDelete.dialogTemplate,
                    controller: 'ConfirmationDialogCtrl',
                    controllerAs: 'vm',
                    appendElement: angular.element('.modal-wrapper'),
                    inputs: {
                        dialogOptions: {}
                    }
                }), function(am) {
                    am.modal.closed.then(function(res) {
                        if (res) {
                            const selectedView = mem.pageData.view_options.selected_view;
                            const ds = mem.pageData.filters.datasource.saved_view.delete;
                            const url = decodeURI(ds.url).replace(urlReplacerRegex, (match, submatch) => {
                                return lodash.get(selectedView, submatch, '');
                            });
                            const method = lodash.get(ds, 'method', 'delete');
                            const resource = GenericModel(url);
                            resource[method]().$promise.then(function (res) {
                                clearFilters();
                                refreshView();

                                ActionManager('notify', lodash.get(mem.options, 'view_options.notification.delete.success', {
                                    template: 'delete success',
                                }))
                            }, function (res) {
                                ActionManager('notify', lodash.get(mem.options, 'view_options.notification.delete.error', {
                                    template: 'delete error',
                                }))
                            });
                        }
                    });
                });
            }

            function setActiveFilter(type, value) {
                lodash.set(mem.pageData.filters, 'active_filters.' + type, value);
            }

            function getActiveFilters() {
                const activeFilters = lodash.get(mem.pageData.filters, 'active_filters', {});
                return lodash.isEmpty(activeFilters) ? null : activeFilters;
            }

            function setSearchBar(value) {
                var isSimpleSearch = lodash.get(mem, 'pageData.toolbar.searchBarConfig.simple', true);
                if (isSimpleSearch) {
                    mem.pageData.toolbar.searchText = value;
                } else {
                    mem.pageData.toolbar.searchData.condition = value.condition;
                    // mem.pageData.toolbar.searchData.items = value.items;
                    // console.log('mem.pageData.toolbar.searchData.items', mem.pageData.toolbar.searchData.items);
                    mem.pageData.toolbar.searchBarInstance.setValue(value.items, true);
                    mem.pageData.toolbar.searchBarOptions = value.items.map(function(item) {
                        return {text:item, value: item};
                    });
                    lodash.set(mem.pageData, 'toolbar.searchDataTemp.items', value.items);
                    lodash.set(mem.pageData, 'toolbar.searchData.items', value.items);
                    // mem.pageData.toolbar.searchBarInstance.refreshItems();

                }
            }

            function clearSearchBar() {
                var isSimpleSearch = lodash.get(mem, 'pageData.toolbar.searchBarConfig.simple', true);
                if (isSimpleSearch) {
                    mem.pageData.toolbar.searchText = '';
                } else {
                    mem.pageData.toolbar.searchData.condition = 'and';
                    mem.pageData.toolbar.searchData.items = [];
                    mem.pageData.toolbar.searchBarOptions = [];
                    // mem.pageData.toolbar.searchBarInstance.refreshItems()
                }
            }

            function hasFilter(appliedFilter) {
                return !!getFilter(appliedFilter.field);
            }
        };
    }
})();
